var submitSVGs = document.querySelectorAll(".icon--header-search");
submitSVGs.forEach(function (svg) {
  svg.addEventListener("click", function () {
    $("#search-drawer").attr("open", true);
  });
});

try {
  /* desktop menu switcher */
  $(".main-menu-switcher").click(function () {
    $(".brand-menu-switcher").removeClass("active");
    $(".brand-menu-desktop").removeClass("active");
    $(this).addClass("active");
    $(".main-menu-desktop").addClass("active");
  });

  $(".brand-menu-switcher").click(function () {
    $(".main-menu-switcher").removeClass("active");
    $(".main-menu-desktop").removeClass("active");
    $(this).addClass("active");
    $(".brand-menu-desktop").addClass("active");
  });
  /* desktop menu switcher */
} catch (e) {}

function getProductDataForRequiresCheckbox(form) {
  const productFormElement = form.closest(".product-form");
  if (!productFormElement) {
    return null;
  }

  let productJsonElement = productFormElement.querySelector("[data-product-json]");

  if (
    !productJsonElement &&
    productFormElement.previousElementSibling &&
    productFormElement.previousElementSibling.matches("[data-product-json]")
  ) {
    productJsonElement = productFormElement.previousElementSibling;
  }

  if (!productJsonElement) {
    return null;
  }

  try {
    return JSON.parse(productJsonElement.textContent);
  } catch (error) {
    return null;
  }
}

function updateRequiresCheckboxPropertyForForm(form) {
  const propertyElements = Array.from(
    form.querySelectorAll("[data-requires-checkbox-property]")
  );

  if (!propertyElements.length) {
    return;
  }

  const idElement = form.querySelector('[name="id"]');
  const variantId = idElement ? parseInt(idElement.value, 10) : NaN;
  const productData = getProductDataForRequiresCheckbox(form);

  if (!productData || !variantId) {
    return;
  }

  const currentVariant = productData.variants.find(
    (variant) => variant.id === variantId
  );

  if (!currentVariant) {
    return;
  }

  const requiresCheckbox =
    currentVariant.sku && currentVariant.sku.indexOf("0_") === 0
      ? "true"
      : "false";

  propertyElements.forEach((propertyElement) => {
    propertyElement.value = requiresCheckbox;
  });
}

document.addEventListener(
  "submit",
  function (event) {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    if (!form.matches("form[is='product-form']")) {
      return;
    }

    updateRequiresCheckboxPropertyForForm(form);
  },
  true
);

document.addEventListener("variant:changed", function (event) {
  const target = event.target;
  const form =
    target instanceof HTMLFormElement
      ? target
      : target && target.closest
        ? target.closest("form[is='product-form']")
        : null;

  if (!form) {
    return;
  }

  updateRequiresCheckboxPropertyForForm(form);
});

// $(function () {
//   setTimeout(function () {
//     var tn = $(".CarouselWidget .R-TextBody .cssVar-subheading__number")
//       .eq(1)
//       .text();
//     var an = $(".CarouselWidget .R-TextBody .cssVar-subheading__number")
//       .eq(0)
//       .text();

//     $("#text-banner-widget .average_rating").text(`${an} /5`);
//     $("#text-banner-widget .ed-reviews-amount").text(`(${tn} Bewertungen)`);
//   }, 2000);
// });
$(document).on("click", ".variant-click", function (e) {
  e.preventDefault();
  var variantId = $("input", this).val();
  var card = ".product-form.product_" + $(this).attr("data-card");
  var productCardElement = $(this).closest(card)[0] || document.querySelector(card);

  let price = $(this).attr("data-price");
  $(card + ' [name="id"]').val($("input", this).val());
  $(card + " .product-form__input label").removeClass("active");

  let productJsonElement = productCardElement
    ? productCardElement.querySelector("[data-product-json]")
    : document.querySelector("[data-product-json]");

  if (
    !productJsonElement &&
    productCardElement &&
    productCardElement.previousElementSibling &&
    productCardElement.previousElementSibling.matches("[data-product-json]")
  ) {
    productJsonElement = productCardElement.previousElementSibling;
  }

  let productJSON = productJsonElement
    ? JSON.parse(productJsonElement.innerHTML)
    : { variants: [] };
  let variants = productJSON.variants;
  let currentVariant = variants.find(
    (variant) => variant.id == $("input", this).val()
  );
  let requiresCheckboxPropertyElements = productCardElement
    ? Array.from(
        productCardElement.querySelectorAll("[data-requires-checkbox-property]")
      )
    : Array.from($(card).find("[data-requires-checkbox-property]"));

  if (requiresCheckboxPropertyElements.length) {
    let requiresCheckbox =
      currentVariant &&
      currentVariant.sku &&
      currentVariant.sku.indexOf("0_") === 0
        ? "true"
        : "false";

    requiresCheckboxPropertyElements.forEach(function (propertyElement) {
      propertyElement.value = requiresCheckbox;
    });
  }

  document.dispatchEvent(
    new CustomEvent("variant::changed", {
      bubbles: true,
      detail: {
        variant: currentVariant,
        previousVariant: currentVariant,
      },
    })
  );

  let sectionId = productCardElement
    ? productCardElement.dataset.sectionId
    : document.querySelector("div.product-form").dataset.sectionId;

  let productUrl = $(this).attr("data-product-url");
  fetch(`${productUrl}?variant=${variantId}&section-id=${sectionId}`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const priceSource = html.getElementById(
        `product-meta__price-container-${sectionId}`
      )
        ? html.getElementById(`product-meta__price-list-container-${sectionId}`)
        : html.querySelector(".ed-product-meta__price-list-container-sticky");

      const $quickBuyWrapper = $(this).closest("quick-buy-drawer")
        ? $(this).closest("quick-buy-drawer")
        : $(this).closest("quick-buy-popover");

      const $quickView = $(this).closest("#quick-view");
      if ($quickView.length) {
        let $priceDestinationQickview = $quickView.find(
          `#product-meta__price-list-container-${sectionId}`
        );
        if (priceSource && $priceDestinationQickview)
          $priceDestinationQickview.html(priceSource.innerHTML);
      } else if ($quickBuyWrapper.length) {
        let $priceDestination = $quickBuyWrapper.find(
          `#product-meta__price-list-container-${sectionId}`
        );
        if (priceSource && $priceDestination)
          $priceDestination.html(priceSource.innerHTML);
      } else {
        let priceDestination = document.getElementById(
          `product-meta__price-list-container-${sectionId}`
        );
        if (priceSource && priceDestination)
          priceDestination.innerHTML = priceSource.innerHTML;
      }

      const variantInfooTextDestination = document.getElementById(
        `product-form__text_wrapper-${sectionId}`
      );
      const variantInfooTextSource = html.getElementById(
        `product-form__text_wrapper-${sectionId}`
      );

      if (variantInfooTextSource && variantInfooTextDestination)
        variantInfooTextDestination.innerHTML =
          variantInfooTextSource.innerHTML;

      const productMetaTaxesIncludedDestination = document.getElementById(
        `product-meta__taxes-included-${sectionId}`
      );
      const productMetaTaxesIncludedSource = html.getElementById(
        `product-meta__taxes-included-${sectionId}`
      );

      if (productMetaTaxesIncludedSource && productMetaTaxesIncludedDestination)
        productMetaTaxesIncludedDestination.innerHTML =
          productMetaTaxesIncludedSource.innerHTML;
    });

  $(this).addClass("active");
});

const scroll = document.querySelector(".items_swap");
var isDown = false;
var scrollX;
var scrollLeft;

if (document.querySelector(".items_swap")) {
  // Mouse Up Function
  document.querySelector(".items_swap").addEventListener("mouseup", () => {
    isDown = false;
    scroll.classList.remove("swap_on");
  });

  // Mouse Leave Function
  document.querySelector(".items_swap").addEventListener("mouseleave", () => {
    isDown = false;
    document.querySelector(".items_swap").classList.remove("swap_on");
  });

  // Mouse Down Function
  document.querySelector(".items_swap").addEventListener("mousedown", (e) => {
    e.preventDefault();
    isDown = true;
    document.querySelector(".items_swap").classList.add("swap_on");
    scrollX = e.pageX - scroll.offsetLeft;
    scrollLeft = scroll.scrollLeft;
  });

  // Mouse Move Function
  document.querySelector(".items_swap").addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    var element = e.pageX - scroll.offsetLeft;
    var scrolling = (element - scrollX) * 2;
    document.querySelector(".items_swap").scrollLeft = scrollLeft - scrolling;
  });
}

var isDown = false;
var scrollX;
var scrollLeft;

if (document.querySelector(".list-collections__item-list")) {
  // Mouse Up Function
  document
    .querySelector(".list-collections__item-list")
    .addEventListener("mouseup", () => {
      isDown = false;
      scroll.classList.remove("swap_start");
    });

  // Mouse Leave Function
  document
    .querySelector(".list-collections__item-list")
    .addEventListener("mouseleave", () => {
      isDown = false;
      document
        .querySelector(".list-collections__item-list")
        .classList.remove("swap_start");
    });

  // Mouse Down Function
  document
    .querySelector(".list-collections__item-list")
    .addEventListener("mousedown", (e) => {
      e.preventDefault();
      isDown = true;
      document
        .querySelector(".list-collections__item-list")
        .classList.add("swap_start");
      scrollX = e.pageX - scroll.offsetLeft;
      scrollLeft = scroll.scrollLeft;
    });

  // Mouse Move Function
  document
    .querySelector(".list-collections__item-list")
    .addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      var element = e.pageX - scroll.offsetLeft;
      var scrolling = (element - scrollX) * 2;
      document.querySelector(".list-collections__item-list").scrollLeft =
        scrollLeft - scrolling;
    });
}

async function _addToCart(variantId, quantity, requiresCheckbox = "false") {
  const productForm = new FormData();
  productForm.append("sections", ["mini-cart"]);
  productForm.append("items[0][id]", variantId);
  productForm.append("items[0][quantity]", quantity);
  productForm.append(
    "items[0][properties][_requires_checkbox]",
    requiresCheckbox
  );
  const response = await fetch(
    `${window.themeVariables.routes.cartAddUrl}.js`,
    {
      body: productForm,
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    }
  );

  const responseJson = await response.json();
  if (response.ok) {
    this.dispatchEvent(
      new CustomEvent("variant:added", {
        bubbles: true,
        detail: {
          variant: responseJson.hasOwnProperty("items")
            ? responseJson["items"][0]
            : responseJson,
        },
      })
    );
    fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
      async (response2) => {
        const cartContent = await response2.json();
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              cart: cartContent,
            },
          })
        );
        cartContent["sections"] = responseJson["sections"];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
              openMiniCart:
                window.themeVariables.settings.cartType === "drawer" && false,
            },
          })
        );
      }
    );
  }
}

$(".mega_menu_wrapper_main > .nav-dropdown__item").on(
  "mouseenter",
  function () {
    $(this).removeClass("narrow").addClass("hovered");
    $(this).siblings().removeClass("hovered").addClass("narrow");
    $(this).siblings().removeClass("is-current-page");
  }
);
$(".mega_menu_wrapper_main > .nav-dropdown__item").on(
  "mouseleave",
  function () {
    $(this).removeClass("narrow").removeClass("hovered");
    $(this).siblings().removeClass("hovered").removeClass("narrow");
  }
);
$("desktop-navigation .header__linklist>li.header__linklist-item").on(
  "mouseleave",
  function () {
    $(
      "desktop-navigation .mega_menu_wrapper_main>li.nav-dropdown__item[selected_url]"
    ).addClass("is-current-page");
  }
);

$(".mega_menu_wrapper_main > .nav-dropdown__item:first-of-type").addClass(
  "hovered"
);

// Deposit item api
document.documentElement.addEventListener("cart:updated", handleCartUpdate);
const blockBtns = (show) => {
  const btns = document.querySelectorAll(
    "#mini-cart-form .line-item__quantity "
  );
  btns.forEach((btn) => {
    btn.style.pointerEvents = show ? "visible" : "none";
  });
};
async function handleCartUpdate() {
  try {
    blockBtns(false);
    await ensureDepositItems();
    console.log("Cart update handled.");
    setTimeout(function () {
      hideComparePrice();
    }, 2000);
  } catch (error) {
    console.error("Fehler bei der Aktualisierung des Warenkorbs:", error);
  } finally {
    blockBtns(true);
  }
}

function hideComparePrice() {
  $(".line-item").each(function () {
    var lineItem = $(this);
    if (lineItem.find(".discounted_price").length > 0) {
      lineItem.find(".price--compare").hide();

      var comparePrice = parseFloat(
        lineItem
          .find(".original_price")
          .text()
          .replace("$", "")
          .replace(",", "")
          .replace(".", "")
      );

      var discountedPrice = parseFloat(
        lineItem
          .find(".discounted_price")
          .text()
          .replace("$", "")
          .replace(",", "")
          .replace(".", "")
      );

      var priceDifference = comparePrice - discountedPrice;

      var existingSavings = parseFloat(lineItem.find(".savings").text());

      var formattedPriceDifference = priceDifference / 100 + existingSavings;

      if (lineItem.find(".new-savings").length > 0) {
        lineItem.find(".new-savings").text(formattedPriceDifference.toFixed(2));
      } else {
        var newSavingsSpan = $("<span>")
          .addClass("new-savings")

          .text(formattedPriceDifference.toFixed(2));

        lineItem.find(".savings").hide();

        lineItem.find(".savings").after(newSavingsSpan);
      }
    }
  });
}

async function ensureDepositItems() {
  const customCart = await fetchCustomCart();
  const updates = {};

  const depositItemId = customCart?.deposit_item?.id;
  if (depositItemId) {
    const requiredDepositItemsCount = calculateRequiredDepositItems(
      customCart,
      depositItemId
    );

    if (
      requiredDepositItemsCount !==
      getCurrentDepositItemCount(customCart, depositItemId)
    ) {
      updates[depositItemId] = requiredDepositItemsCount;
    }
  }

  const configuredRentalDepositItemId =
    customCart?.rental_deposit?.deposit_item?.id;
  const rentalDepositCartItems = customCart.items.filter((item) => {
    return (
      item.is_rental_deposit ||
      (configuredRentalDepositItemId && item.id === configuredRentalDepositItemId)
    );
  });
  const rentalDepositItemId =
    configuredRentalDepositItemId || rentalDepositCartItems[0]?.id;

  if (rentalDepositItemId) {
    const requiredRentalDepositItemsCount =
      calculateRequiredRentalDepositItems(customCart);

    if (rentalDepositCartItems.length > 0) {
      rentalDepositCartItems.forEach((item, index) => {
        const desiredQuantity = index === 0 ? requiredRentalDepositItemsCount : 0;

        if (item.quantity !== desiredQuantity) {
          updates[item.key] = desiredQuantity;
        }
      });
    } else if (requiredRentalDepositItemsCount > 0) {
      updates[rentalDepositItemId] = requiredRentalDepositItemsCount;
    }
  }

  if (Object.keys(updates).length > 0) {
    const response = await fetch(
      `${window.themeVariables.routes.cartUrl}/update.js`,
      {
        body: JSON.stringify({
          sections: ["mini-cart"],
          updates: updates,
        }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(
        `Fehler beim Abrufen von Warenkorbdaten. Statuscode: ${response.status}`
      );
    }

    const cartContent = await response.json();
    await dispatchCartEvent("cart:updated", cartContent);
    await dispatchCartEvent("cart:refresh", cartContent);
  }
}

async function fetchCustomCart() {
  const response = await fetch(
    `${window.themeVariables.routes.rootUrl}?view=cart`
  );
  return response.json();
}

function calculateRequiredDepositItems(cart, depositItemId) {
  return cart.items.reduce((count, item) => {
    return item.require_deposit ? count + item.quantity : count;
  }, 0);
}

function getCurrentDepositItemCount(cart, depositItemId) {
  const depositItem = cart.items.find((item) => item.id === depositItemId);
  return depositItem ? depositItem.quantity : 0;
}

function calculateRequiredRentalDepositItems(cart) {
  return cart.items.reduce((count, item) => {
    return item.is_rental_product ? count + item.quantity : count;
  }, 0);
}

async function updateCart(depositItemId, requiredQuantity) {
  const response = await fetch(
    `${window.themeVariables.routes.cartUrl}/update.js`,
    {
      body: JSON.stringify({
        sections: ["mini-cart"],
        updates: { [depositItemId]: requiredQuantity },
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error(
      `Fehler beim Abrufen von Warenkorbdaten. Statuscode: ${response.status}`
    );
  }

  const cartContent = await response.json();
  await dispatchCartEvent("cart:updated", cartContent);
  await dispatchCartEvent("cart:refresh", cartContent);
  blockBtns(true);
}

async function dispatchCartEvent(eventName, cartContent) {
  document.documentElement.dispatchEvent(
    new CustomEvent(eventName, {
      bubbles: true,
      detail: { cart: cartContent },
    })
  );
}

// Initialer Aufruf
ensureDepositItems();

/* Priority shipping api */
window.ensureNoPriorityShippingProductWhenNotEnabled = async function (
  customCart
) {
  const priorityShippingItemId = customCart?.priority_shipping_item?.id;
  const cartHasPriorityShipping = customCart.items.filter(function (item) {
    return item.id === priorityShippingItemId;
  });

  if (
    window.priorityShippingIsDisabled === true &&
    cartHasPriorityShipping.length > 0
  ) {
    // If Priority Shipping is disabled but present in the cart, remove it from the cart
    const response = await fetch(
      `${window.themeVariables.routes.cartUrl}/update.js`,
      {
        body: JSON.stringify({
          sections: ["mini-cart"],
          updates: { [priorityShippingItemId]: 0 },
        }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const cartContent = await response.json();
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart: cartContent,
        },
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartContent,
        },
      })
    );
  } else if (
    window.priorityShippingIsDisabled === false &&
    cartHasPriorityShipping.length > 1
  ) {
    // If Priority Shipping is enabled and more than 1 instance is in the cart, set the quantity to 1
    const response = await fetch(
      `${window.themeVariables.routes.cartUrl}/update.js`,
      {
        body: JSON.stringify({
          sections: ["mini-cart"],
          updates: { [priorityShippingItemId]: 1 },
        }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const cartContent = await response.json();
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart: cartContent,
        },
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartContent,
        },
      })
    );
  }
};

/* [END] Priority shipping api */

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

$(function () {
  $(document).on("click", ".mobile_info_wrapper .tab_question", function (j) {
    var dropDowns = $(this)
      .closest(".mobile_info_wrapper .tabbers_item")
      .find(".mobile_info_wrapper .tab_answer");
    $(this)
      .closest(".mobile_info_wrapper .tabbers_item")
      .find(".mobile_info_wrapper .tab_answer")
      .not(dropDowns)
      .slideUp();
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      $(this)
        .closest(".mobile_info_wrapper .tabbers_item")
        .find(".mobile_info_wrapper .tab_question.active")
        .removeClass("active");
      $(this).addClass("active");
    }

    dropDowns.stop(false, true).slideToggle();
    j.preventDefault();
  });
});

$(document).ready(function(){
  document.querySelectorAll('.battery_finder_label[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
          e.preventDefault();
          document.querySelector(this.getAttribute('href')).scrollIntoView({
              behavior: 'smooth'
          });
      });
  });

  // $('.filter-nav-item-heading').click(function() {
  //   if($(this).hasClass('active')){
  //     $(this).closest('.filter-nav-item').removeClass('active_tab');
  //     $(this).removeClass('active');  
  //     $(this).siblings('.filter-nav-item-content').slideUp();
  //   }else{
  //     $('.filter-nav-item').removeClass('active_tab'); 
  //     $(this).closest('.filter-nav-item').toggleClass('active_tab');
  //     $(this).addClass('active');
  //     $(this).siblings('.filter-nav-item-content').slideDown();
  //   }
  // });

  // const productCount = document.querySelector('.b-product-facet__meta-bar .total_product_count');
  // const mainCount = document.querySelector('#facet-main');
  
  // if (mainCount) {
  //   new MutationObserver(() => {
  //     const updatedCount = mainCount.querySelector('.test_a_sorting .total_product_count').textContent;
  //     productCount.textContent = updatedCount;
  //   }).observe(mainCount, { childList: true, subtree: true });
  // }
  
});

// $(document).on('change','#search-drawer .predictive-search__input',function(){
//   const element = document.querySelector('.predictive-search-main');
//   if (element) {
//     element.remove();
//   }
// });
// $(document).on('click','.variation-A-search .predictive-search__form',function(){
//   const element = document.querySelector('.predictive-search-main');
//   if (element) {
//     element.remove();
//     $('#search-drawer').attr('open');
//   }
// });

document.documentElement.addEventListener('cart:updated', function(event) {
  update_pshipping();
});

(function () {
  var hydrationTimer;
  var hydrationSequence = 0;

  function getProductKey(productItem) {
    var productLink = productItem.querySelector('a[href*="/products/"]');
    return productItem.getAttribute('data-product-id') || (productLink ? productLink.href : productItem.textContent.trim());
  }

  function updateFullySoldOutCounts(facetMain, count, productLabel) {
    var scope = facetMain.closest('.shopify-section') || document;

    scope.querySelectorAll('.total_product_count, .product-facet__meta-bar-item--count').forEach(function (element) {
      element.textContent = count + ' ' + productLabel;
    });

    document.querySelectorAll('input[name="filter.v.availability"][value="0"]').forEach(function (input) {
      var label = input.closest('label');
      var countElement = label ? label.querySelector('.alpha-facet__count, .sd-count') : null;

      if (countElement) {
        countElement.textContent = countElement.classList.contains('alpha-facet__count') ? '(' + count + ')' : count;
      }
    });
  }

  function getFullySoldOutPageUrl(pageNumber) {
    var pageUrl = new URL(window.location.href);
    pageUrl.searchParams.delete('section_id');

    if (pageNumber > 1) {
      pageUrl.searchParams.set('page', pageNumber.toString());
    } else {
      pageUrl.searchParams.delete('page');
    }

    return pageUrl;
  }

  function getFullySoldOutPaginationParts(currentPage, totalPages) {
    var visiblePages = new Set([1, totalPages]);

    for (var pageNumber = currentPage - 2; pageNumber <= currentPage + 2; pageNumber += 1) {
      if (pageNumber > 1 && pageNumber < totalPages) {
        visiblePages.add(pageNumber);
      }
    }

    var sortedPages = Array.from(visiblePages).sort(function (firstPage, secondPage) {
      return firstPage - secondPage;
    });
    var paginationParts = [];

    sortedPages.forEach(function (pageNumber, index) {
      if (index > 0 && pageNumber - sortedPages[index - 1] > 1) {
        paginationParts.push(null);
      }

      paginationParts.push(pageNumber);
    });

    return paginationParts;
  }

  function renderFullySoldOutPagination(facetMain, requestedPage, historyMode) {
    var marker = facetMain.querySelector('[data-fully-sold-out-filter]');
    var productList = facetMain.querySelector('product-list');
    var productItems = productList ? Array.from(productList.querySelectorAll('.product-list__inner .product-item--sold-out')) : [];

    if (!marker || !productList) {
      return;
    }

    var pageSize = Math.max(1, parseInt(marker.dataset.pageSize, 10) || productItems.length || 1);
    var totalPages = Math.max(1, Math.ceil(productItems.length / pageSize));
    var currentPage = Math.min(Math.max(1, parseInt(requestedPage, 10) || 1), totalPages);

    productItems.forEach(function (productItem, index) {
      var isVisibleOnCurrentPage = Math.floor(index / pageSize) + 1 === currentPage;
      productItem.hidden = !isVisibleOnCurrentPage;
      productItem.style.display = isVisibleOnCurrentPage ? '' : 'none';
    });

    facetMain.querySelectorAll('[data-fully-sold-out-pagination]').forEach(function (pagination) {
      pagination.remove();
    });

    if (totalPages > 1) {
      var pagination = document.createElement('div');
      var paginationNavigation = document.createElement('nav');
      pagination.className = 'pagination';
      pagination.setAttribute('data-fully-sold-out-pagination', '');
      paginationNavigation.className = 'pagination__nav';

      function appendPageLink(pageNumber, label, relation, content) {
        var pageLink = document.createElement('a');
        pageLink.className = 'pagination__nav-item heading heading--small';
        pageLink.href = getFullySoldOutPageUrl(pageNumber).toString();
        pageLink.setAttribute('data-fully-sold-out-page', pageNumber.toString());
        pageLink.setAttribute('aria-label', label);

        if (relation) {
          pageLink.rel = relation;
        }

        pageLink.textContent = content;
        paginationNavigation.appendChild(pageLink);
      }

      if (currentPage > 1) {
        appendPageLink(currentPage - 1, marker.dataset.previousLabel || 'Previous page', 'prev', '←');
      }

      getFullySoldOutPaginationParts(currentPage, totalPages).forEach(function (pageNumber) {
        if (pageNumber === null) {
          var ellipsis = document.createElement('span');
          ellipsis.className = 'pagination__nav-item heading heading--small';
          ellipsis.setAttribute('aria-hidden', 'true');
          ellipsis.textContent = '…';
          paginationNavigation.appendChild(ellipsis);
        } else if (pageNumber === currentPage) {
          var currentPageElement = document.createElement('span');
          currentPageElement.className = 'pagination__nav-item heading heading--small';
          currentPageElement.setAttribute('aria-current', 'page');
          currentPageElement.textContent = pageNumber.toString();
          paginationNavigation.appendChild(currentPageElement);
        } else {
          var pageLabel = (marker.dataset.pageLabelTemplate || 'Page __PAGE__').replace('__PAGE__', pageNumber.toString());
          appendPageLink(pageNumber, pageLabel, '', pageNumber.toString());
        }
      });

      if (currentPage < totalPages) {
        appendPageLink(currentPage + 1, marker.dataset.nextLabel || 'Next page', 'next', '→');
      }

      pagination.appendChild(paginationNavigation);
      productList.insertAdjacentElement('afterend', pagination);
    }

    marker.dataset.currentClientPage = currentPage.toString();

    if (historyMode || currentPage !== parseInt(requestedPage, 10)) {
      var pageUrl = getFullySoldOutPageUrl(currentPage);

      if (historyMode === 'push') {
        window.history.pushState({}, '', pageUrl.toString());
      } else {
        window.history.replaceState({}, '', pageUrl.toString());
      }
    }
  }

  async function hydrateFullySoldOutCollection() {
    var facetMain = document.querySelector('#facet-main');
    var marker = facetMain ? facetMain.querySelector('[data-fully-sold-out-filter]') : null;

    if (!facetMain || !marker || marker.dataset.hydrationStatus === 'loading' || marker.dataset.hydrationStatus === 'complete') {
      return;
    }

    var productList = facetMain.querySelector('product-list');
    var productListInner = productList ? productList.querySelector('.product-list__inner') : null;

    if (!productListInner) {
      return;
    }

    marker.dataset.hydrationStatus = 'loading';
    hydrationSequence += 1;
    var hydrationToken = hydrationSequence.toString();
    facetMain.dataset.fullySoldOutHydration = hydrationToken;

    try {
      var sourcePages = Math.max(1, parseInt(marker.dataset.sourcePages, 10) || 1);
      var currentPage = Math.max(1, parseInt(marker.dataset.currentPage, 10) || 1);
      var sectionId = facetMain.getAttribute('data-section-id');
      var sourcePageProducts = {};
      sourcePageProducts[currentPage] = Array.from(productListInner.querySelectorAll('.product-item--sold-out'));

      var sourcePageNumbers = [];

      for (var page = 1; page <= sourcePages; page += 1) {
        if (page === currentPage) {
          continue;
        }

        sourcePageNumbers.push(page);
      }

      var sourcePageDocuments = await Promise.all(sourcePageNumbers.map(async function (pageNumber) {
        var pageUrl = new URL(window.location.href);
        pageUrl.searchParams.set('page', pageNumber.toString());

        if (sectionId) {
          pageUrl.searchParams.set('section_id', sectionId);
        }

        var response = await fetch(pageUrl.toString());

        if (!response.ok) {
          throw new Error('Unable to load fully sold out products from page ' + pageNumber);
        }

        var responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
        var responseMarker = responseDocument.querySelector('#facet-main [data-fully-sold-out-filter]');

        if (!responseMarker) {
          throw new Error('Fully sold out filter state was not preserved for page ' + pageNumber);
        }

        return {
          pageNumber: pageNumber,
          responseDocument: responseDocument
        };
      }));

      if (
        facetMain.dataset.fullySoldOutHydration !== hydrationToken ||
        !marker.isConnected ||
        facetMain.querySelector('[data-fully-sold-out-filter]') !== marker
      ) {
        return;
      }

      sourcePageDocuments.forEach(function (sourcePageDocument) {
        sourcePageProducts[sourcePageDocument.pageNumber] = Array.from(
          sourcePageDocument.responseDocument.querySelectorAll('#facet-main .product-list__inner .product-item--sold-out')
        );
      });

      productListInner.querySelectorAll('.product-item').forEach(function (productItem) {
        productItem.remove();
      });

      var productKeys = new Set();

      for (var sourcePage = 1; sourcePage <= sourcePages; sourcePage += 1) {
        (sourcePageProducts[sourcePage] || []).forEach(function (productItem) {
          var productKey = getProductKey(productItem);

          if (!productKeys.has(productKey)) {
            productKeys.add(productKey);
            productListInner.appendChild(productItem);
          }
        });
      }

      productListInner.querySelectorAll('.product-item:not(.product-item--sold-out)').forEach(function (productItem) {
        productItem.remove();
      });

      productListInner.querySelectorAll('.product-item--sold-out').forEach(function (productItem) {
        productItem.removeAttribute('reveal');
        productItem.style.opacity = '1';
        productItem.style.transform = 'none';
      });

      var productCount = productListInner.querySelectorAll('.product-item--sold-out').length;
      var emptyState = facetMain.querySelector('[data-fully-sold-out-empty]');

      productList.hidden = productCount === 0;

      if (emptyState) {
        emptyState.hidden = productCount !== 0;
      }

      facetMain.querySelectorAll('page-pagination').forEach(function (pagination) {
        pagination.remove();
      });

      updateFullySoldOutCounts(facetMain, productCount, marker.dataset.productLabel || 'Produkte');
      marker.dataset.hydrationStatus = 'complete';
      renderFullySoldOutPagination(facetMain, new URL(window.location.href).searchParams.get('page'), null);
    } catch (error) {
      marker.dataset.hydrationStatus = 'error';
      console.error('Fully sold out collection filter error:', error);
    }
  }

  function scheduleFullySoldOutHydration() {
    window.clearTimeout(hydrationTimer);
    hydrationTimer = window.setTimeout(hydrateFullySoldOutCollection, 0);
  }

  document.addEventListener('click', function (event) {
    var pageLink = event.target.closest('[data-fully-sold-out-page]');

    if (!pageLink) {
      return;
    }

    var facetMain = pageLink.closest('#facet-main');

    if (!facetMain) {
      return;
    }

    event.preventDefault();
    renderFullySoldOutPagination(facetMain, pageLink.dataset.fullySoldOutPage, 'push');
    facetMain.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  window.addEventListener('popstate', function () {
    var facetMain = document.querySelector('#facet-main');
    var marker = facetMain ? facetMain.querySelector('[data-fully-sold-out-filter]') : null;

    if (facetMain && marker && marker.dataset.hydrationStatus === 'complete') {
      renderFullySoldOutPagination(facetMain, new URL(window.location.href).searchParams.get('page'), null);
    }
  });

  new MutationObserver(scheduleFullySoldOutHydration).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleFullySoldOutHydration);
  } else {
    scheduleFullySoldOutHydration();
  }
})();
